import { Navigate, useLocation } from 'react-router-dom';
import useLanguageNavigation from '@/hooks/useLanguageNavigation.js';
import { useAuth } from '../context/AuthContext.jsx';

const Loader = () => (
  <div className="page-loader">
    <div className="spinner" />
    <span>Загрузка...</span>
  </div>
);

export const RequireAuth = ({ children }) => {
  const { isAuthenticated, initializing } = useAuth();
  const { getLocalizedPath } = useLanguageNavigation();
  const location = useLocation();

  console.debug('[GUARD:RequireAuth] render', {
    pathname: location.pathname,
    isAuthenticated,
    isLoadingAuth: initializing,
  });

  if (initializing) {
    return <Loader />;
  }
  if (!isAuthenticated) {
    const currentFullPath = `${location.pathname}${location.search}${location.hash}`;
    const loginPath = getLocalizedPath('/login', {
      search: `?returnUrl=${encodeURIComponent(currentFullPath)}`,
    });
    console.debug('[GUARD:RequireAuth] redirect', {
      from: location.pathname,
      to: loginPath,
      reason: '!isAuthenticated',
    });
    return <Navigate to={loginPath} replace />;
  }
  return children;
};

export const PublicOnlyRoute = ({ children }) => {
  const { isAuthenticated, initializing } = useAuth();
  const { getLocalizedPath } = useLanguageNavigation();
  const location = useLocation();

  console.debug('[GUARD:PublicOnly] render', {
    pathname: location.pathname,
    isAuthenticated,
    isLoadingAuth: initializing,
  });

  if (initializing) {
    return <Loader />;
  }
  if (isAuthenticated) {
    console.debug('[GUARD:PublicOnly] redirect', {
      from: location.pathname,
      to: getLocalizedPath('/dashboard/create-game'),
      reason: 'isAuthenticated',
    });
    return <Navigate to={getLocalizedPath('/dashboard/create-game')} replace />;
  }
  return children;
};
